import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '../Avatar/Avatar';
import './NotificationToast.scss';

export const NotificationToast = ({
  title,
  subtitle,
  avatar,
  status = 'pending',
}) => {
  const displayStatus = (status || 'pending').toLowerCase();

  return (
    <div className={`notification-toast notification-toast--${displayStatus}`}>
      <div className='notification-toast__left'>
        <Avatar size='sm' src={avatar} name={title} />
      </div>

      <div className='notification-toast__content'>
        <div className='notification-toast__top'>
          <div className='notification-toast__title'>{title}</div>
          <div
            className={`notification-toast__badge notification-toast__badge--${displayStatus}`}
          >
            {displayStatus}
          </div>
        </div>
        <div className='notification-toast__subtitle'>{subtitle}</div>
      </div>
    </div>
  );
};

NotificationToast.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  avatar: PropTypes.string,
  status: PropTypes.oneOf(['pending', 'accepted', 'declined', 'ignored']),
};
